(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dvp-premium-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dvp-footer-menu')) {
    customElements.define('dvp-footer-menu', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.updateLayout = () => {
          this.details.open = !this.mobile.matches;
          if (this.mobile.matches) {
            this.summary.removeAttribute('tabindex');
          } else {
            this.summary.setAttribute('tabindex', '-1');
          }
        };
        this.onSummaryClick = (event) => {
          if (!this.mobile.matches) event.preventDefault();
        };
        this.mobile.addEventListener('change', this.updateLayout);
        this.summary.addEventListener('click', this.onSummaryClick);
        this.updateLayout();
      }

      disconnectedCallback() {
        this.mobile.removeEventListener('change', this.updateLayout);
        this.summary.removeEventListener('click', this.onSummaryClick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvp-shopping-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dvp-shopping-home')) {
  customElements.define('dvp-shopping-home', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-gear-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-gear-panel]'));
      this.querySelector('.dvp-shopping-tabs').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.removeAttribute('aria-current');
        tab.setAttribute('aria-controls', this.panels[index].id);
        tab.setAttribute('aria-selected', String(index === 0));
        tab.tabIndex = index === 0 ? 0 : -1;
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.selectTab(index);
        }, options);
        tab.addEventListener('keydown', event => {
          if (event.key === ' ') {
            event.preventDefault();
            this.selectTab(index);
            return;
          }
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.selectTab(next);
          this.tabs[next].focus();
        }, options);
      });
      this.selectTab(0);
      this.addEventListener('shopify:block:select', event => {
        if (!event.target.closest('[data-featured-block]')) return;
        const featuredIndex = this.tabs.findIndex(tab => tab.dataset.gearTab === 'featured');
        if (featuredIndex >= 0) this.selectTab(featuredIndex);
      }, options);
      this.form = this.querySelector('form');
      this.input = this.form.querySelector('input[type=search]');
      this.results = this.querySelector('[role=listbox]');
      this.suggestions = this.querySelector('.dvp-shopping-suggestions');
      this.status = this.querySelector('[data-search-status]');
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-controls', this.results.id);
      this.sequence = 0;
      this.activeIndex = -1;
      this.input.addEventListener('input', () => {
        this.invalidate();
        this.close();
        this.results.replaceChildren();
        if (this.input.value.trim().length < 2) return;
        this.timer = setTimeout(() => this.search(), 220);
      }, options);
      this.input.addEventListener('focus', () => {
        if (this.input.value.trim().length >= 2) this.search();
      }, options);
      this.input.addEventListener('keydown', event => {
        const rows = Array.from(this.results.children);
        if (event.key === 'Escape') {
          event.preventDefault();
          this.invalidate();
          this.close();
          return;
        }
        if (this.suggestions.hidden || rows.length === 0) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const change = event.key === 'ArrowDown' ? 1 : -1;
          this.activeIndex = (this.activeIndex + change + rows.length) % rows.length;
          rows.forEach((row, index) => row.setAttribute('aria-selected', String(index === this.activeIndex)));
          this.input.setAttribute('aria-activedescendant', rows[this.activeIndex].id);
        } else if (event.key === 'Enter' && this.activeIndex >= 0) {
          event.preventDefault();
          rows[this.activeIndex].querySelector('a').click();
        }
      }, options);
      this.querySelector('[data-close-search]').addEventListener('click', () => {
        this.input.focus();
        this.invalidate();
        this.close();
      }, options);
      this.form.addEventListener('submit', event => {
        if (!this.input.value.trim()) {
          event.preventDefault();
          this.input.focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) {
          this.invalidate();
          this.close();
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.form.contains(event.target)) {
          this.invalidate();
          this.close();
        }
      }, options);
    }
    selectTab(index) {
      this.tabs.forEach((tab, current) => {
        tab.setAttribute('aria-selected', String(current === index));
        tab.tabIndex = current === index ? 0 : -1;
        this.panels[current].hidden = current !== index;
      });
    }
    invalidate() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.sequence += 1;
    }
    close() {
      this.suggestions.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
    }
    async search() {
      this.invalidate();
      const query = this.input.value.trim();
      if (query.length < 2) return;
      const sequence = this.sequence;
      this.request = new AbortController();
      const url = new URL(this.dataset.predictiveUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      this.status.textContent = this.dataset.loading;
      this.results.replaceChildren();
      this.suggestions.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      try {
        const response = await fetch(url, { signal: this.request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search unavailable');
        const payload = await response.json();
        if (sequence !== this.sequence || this.input.value.trim() !== query) return;
        const products = payload.resources?.results?.products || [];
        if (!products.length) {
          this.status.textContent = this.dataset.empty;
          return;
        }
        const formatter = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
          style: 'currency', currency: this.dataset.currency || 'USD'
        });
        products.forEach((product, index) => {
          const href = new URL(product.url, location.origin);
          if (href.origin !== location.origin) return;
          const row = document.createElement('li');
          row.id = `${this.results.id}-${index}`;
          row.setAttribute('role', 'option');
          row.setAttribute('aria-selected', 'false');
          const link = document.createElement('a');
          link.href = href.href;
          link.tabIndex = -1;
          const img = document.createElement('img');
          const imageUrl = product.featured_image?.url || product.image;
          if (imageUrl) {
            const source = new URL(imageUrl, location.origin);
            if (source.protocol === 'https:') {
              source.searchParams.set('width', '104');
              img.src = source.href;
            }
          }
          img.alt = '';
          img.width = 52;
          img.height = 52;
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = product.title;
          copy.append(title);
          const rawPrice = product.price_min ?? product.price;
          if (rawPrice !== undefined && rawPrice !== null && rawPrice !== '' && Number.isFinite(Number(rawPrice))) {
            const price = document.createElement('small');
            price.textContent = `${product.price_varies ? `${this.dataset.from} ` : ''}${formatter.format(Number(rawPrice))}`;
            copy.append(price);
          }
          link.append(img, copy);
          row.append(link);
          this.results.append(row);
        });
        this.status.textContent = this.dataset.count.replace('__COUNT__', String(this.results.children.length));
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) this.status.textContent = this.dataset.error;
      }
    }
    disconnectedCallback() {
      this.invalidate();
      this.lifecycle?.abort();
      this.initialized = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvp-social-clips"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dvp-social-clips')) {
  customElements.define('dvp-social-clips', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      this.track = this.querySelector('.dvp-social-clips__track');
      this.cards = [...this.querySelectorAll('[data-social-clip]')];
      this.frames = this.cards.map(card => card.querySelector('iframe'));
      this.toggle = this.querySelector('[data-clips-toggle]');
      this.status = this.querySelector('[data-clips-status]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.active = 0;
      this.inView = false;
      this.panel = 'clips';
      this.ready = new Set();
      this.update();
      this.querySelector('[data-clips-next]').addEventListener('click', () => this.select(this.active + 1, true), options);
      this.querySelector('[data-clips-prev]').addEventListener('click', () => this.select(this.active - 1, true), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.update();
        if (this.paused) this.pauseAll(); else this.play();
      }, options);
      const tabs = [...this.querySelectorAll('[data-social-tab]')];
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchPanel(tab.dataset.socialTab), options);
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          this.switchPanel(tabs[next].dataset.socialTab);
          tabs[next].focus();
        }, options);
      });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) {
          this.frames.forEach(frame => { if (!frame.src) frame.src = frame.dataset.tiktokSrc; });
          this.play();
        } else this.pauseAll();
      }, { threshold: 0.12 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseAll(); else this.play(); }, options);
      this.reduced.addEventListener('change', event => { if (event.matches) { this.paused = true; this.pauseAll(); this.update(); } }, options);
      window.addEventListener('message', event => {
        const index = this.frames.findIndex(frame => frame.contentWindow === event.source);
        if (index < 0) return;
        this.frames[index].setAttribute('data-message-origin', event.origin);
        this.frames[index].setAttribute('data-message-format', typeof event.data);
        this.frames[index].setAttribute('data-message-preview', String(event.data).slice(0,600));
        if (event.origin !== 'https://www.tiktok.com') return;
        let payload = event.data;
        if (typeof payload === 'string') { try { payload = JSON.parse(payload); } catch { return; } }
        if (!payload || typeof payload !== 'object') return;
        this.frames[index].setAttribute('data-message-type', String(payload.type || '').slice(0,60));
        if (payload['x-tiktok-player'] !== true) return;
        if (payload.type === 'onPlayerReady') {
          this.frames[index].setAttribute('data-player-ready', 'true');
          this.ready.add(index);
          this.message(index, 'mute');
          if (index === this.active) this.play();
        }
        if (payload.type === 'onStateChange') {
          this.frames[index].setAttribute('data-player-state', String(payload.value));
          if (payload.value === 1 && index !== this.active) this.select(index, true);
          if (payload.value === 0 && index === this.active && !this.paused && this.inView && this.panel === 'clips') this.select(index + 1, false);
          if (payload.value === 2 && index === this.active && this.inView && !document.hidden && this.panel === 'clips') { this.paused = true; this.update(); }
          if (payload.value === 1 && index === this.active && this.paused) { this.paused = false; this.update(); }
        }
        if (payload.type === 'onPlayerError') {
          this.frames[index].setAttribute('data-player-error', JSON.stringify(payload.value));
          this.cards[index].querySelector('.dvp-social-clips__fallback').hidden = false;
          if (index === this.active) { this.paused = true; this.update(); }
        }
      }, options);
    }
    message(index, type) {
      this.frames[index]?.contentWindow?.postMessage({ type, value: null, 'x-tiktok-player': true }, 'https://www.tiktok.com');
    }
    pauseAll() { this.frames.forEach((_, index) => this.message(index, 'pause')); }
    play() {
      if (this.paused || !this.inView || document.hidden || this.panel !== 'clips' || !this.ready.has(this.active)) return;
      this.message(this.active, 'mute');
      this.message(this.active, 'play');
    }
    select(index, manual) {
      if (!this.cards.length) return;
      const previous = this.active;
      this.active = (index + this.cards.length) % this.cards.length;
      if (manual) this.paused = false;
      if (previous !== this.active) this.message(previous, 'pause');
      this.track.scrollTo({ left: this.cards[this.active].offsetLeft, behavior: this.reduced.matches ? 'instant' : 'smooth' });
      this.update();
      this.play();
    }
    update() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.cards.forEach((card, index) => card.toggleAttribute('data-active', index === this.active));
      this.status.textContent = this.cards[this.active]?.querySelector('h3')?.textContent || '';
    }
    switchPanel(name) {
      this.panel = name;
      this.querySelectorAll('[data-social-tab]').forEach(tab => {
        tab.setAttribute('aria-selected', String(tab.dataset.socialTab === name));
        tab.tabIndex = tab.dataset.socialTab === name ? 0 : -1;
      });
      this.querySelectorAll('[data-social-panel]').forEach(panel => { panel.hidden = panel.dataset.socialPanel !== name; });
      this.querySelector('.dvp-social-clips__controls').hidden = name !== 'clips';
      if (name === 'instagram') {
        this.pauseAll();
        const mount = this.querySelector('[data-instagram-mount]');
        mount.replaceChildren(this.querySelector('[data-instagram-template]').content.cloneNode(true));
        if (window.instgrm?.Embeds) window.instgrm.Embeds.process();
        else {
          let script = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
          if (!script) { script = document.createElement('script'); script.src = 'https://www.instagram.com/embed.js'; script.async = true; document.head.append(script); }
          script.addEventListener('load', () => window.instgrm?.Embeds.process(), { once: true, signal: this.lifecycle.signal });
        }
      } else {
        this.querySelector('[data-instagram-mount]')?.replaceChildren();
        this.play();
      }
    }
    disconnectedCallback() {
      this.pauseAll();
      this.observer?.disconnect();
      this.lifecycle?.abort();
      this.started = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
